import useSWR from 'swr';
import {
  IEmailAffiliationResponse,
  IAffiliationResponse,
  IPatchAffiliationResponse,
  IAffiliation,
  ISearchOrgResponse
} from 'typings/organization';
import httpService from 'services/httpService';

const BASE_URL = '/affiliation-service/';

export const useAffiliations = (userId: string) => {
  const { data, error, ...rest } = useSWR<IAffiliationResponse>([
    `${BASE_URL}v2/affiliations/users/${userId}`
  ]);

  return {
    ...rest,
    data: data || [],
    error,
    hasError: Boolean(error),
    isLoading: !data && !error
  };
};

export const getOrganizations = (email: string) => {
  return httpService
    .get<IEmailAffiliationResponse>({
      url: `${BASE_URL}organizations/find-email-affiliation?email=${encodeURIComponent(
        email
      )}`,
      includeAuth: true
    })
    .then(response => response.data);
};

export const getOrganizationsByDomain = (domain: string) => {
  return httpService
    .get<IEmailAffiliationResponse>({
      url: `${BASE_URL}v2/organizations/searchByDomain?domain=${encodeURIComponent(
        domain
      )}`,
      includeAuth: true
    })
    .then(response => response.data);
};

export const addRinggoldAffiliation = (
  organizationId: string,
  email: string,
  role: string,
  startDate: string,
  endDate: string
) =>
  httpService
    .post<IAffiliation>({
      url: `${BASE_URL}v2/affiliations?type=RINGGOLD`,
      data: {
        ringgoldId: organizationId,
        email,
        role,
        startDate,
        endDate
      },
      includeAuth: true
    })
    .then(response => response.data);

export const patchAffiliation = (
  affiliationId: string,
  role: string,
  startDate: string,
  endDate: string,
  type: string
) =>
  httpService
    .patch<IPatchAffiliationResponse>({
      url: `${BASE_URL}v2/affiliations/${affiliationId}?type=${type}`,
      data: {
        role,
        startDate,
        endDate
      },
      includeAuth: true
    })
    .then(response => response.data);

export const addUserProvidedAffiliation = (data: IAffiliation) =>
  httpService
    .post<IAffiliation>({
      url: `${BASE_URL}v2/affiliations?type=USER_PROVIDED`,
      data,
      includeAuth: true
    })
    .then(response => response.data);

export const deleteAffiliation = (id: string, type: string) => {
  return httpService
    .delete<string>({
      url: `${BASE_URL}v2/affiliations/${id}?type=${type}`,
      includeAuth: true
    })
    .then(response => response.data);
};

export const resendAffiliationVerificationEmail = (
  affiliationId: string,
  affiliationType: 'RINGGOLD' | 'USER_PROVIDED'
) =>
  httpService
    .post<any>({
      url: `${BASE_URL}v2/affiliations/${affiliationId}/email-verification?type=${affiliationType}`,
      includeAuth: true
    })
    .then(response => response.data);

export const useFindOrganizations = (queryParams: string, term: string) => {
  const { data, error, ...rest } = useSWR<ISearchOrgResponse>(
    term.length > 0
      ? [`${BASE_URL}organizations/search-by-name${queryParams}`]
      : null
  );
  return {
    ...rest,
    data: data,
    error,
    hasError: Boolean(error),
    isLoading: !data && !error && term.length > 0
  };
};

export const updateUserActivation = (
  userId: string,
  payload: { is_activated: boolean }
) => {
  return httpService.put({
    url: `/events_manager/v2/users/${userId}`,
    includeAuth: true,
    data: payload
  });
};
